<template>
    <div class="custom-bg">
        <div class="v-flex align-items-center justify-content-center min-vh-100 px-2">
            <div class="text-center">
                <h1>404</h1>
                <p>Oops! Page not found</p>
                <p>The page you're looking for doesn't exist or has been moved.</p>
                <router-link  :to="{name : 'dashboard'}"
                    class="btn-primary">
                    Back to Dashboard
                </router-link>
            </div>
        </div>
    </div>
</template>
<style scoped>
.custom-bg{position: absolute; width: 100%; top: 0;
    left: 0; background: var(--background-color); z-index: 99;
    bottom: 0; color: var(--black);}
.custom-bg > div{width:100%; height:100%;}
h1{font-size: 180px;margin: 0; line-height: 1em;}
p{margin:0; font-size: 16px;}
.btn-primary{margin-top: 30px;}
@media screen and (max-width: 700px) {
    .custom-bg > div{padding: 15px}
    h1{font-size: 100px;}
    p{font-size:13px}
}
</style>